import React, { useEffect, useState } from 'react';

const Pagination = ({ itemsPerPage, totalItems, page, onChange }: Props) => {
  const [currentPage, setCurrentPage] = useState(page);

  useEffect(() => {
    setCurrentPage(page);
  }, [ page ]);

  const onPageSelected = (pageNumber: number) => {
    setCurrentPage(pageNumber);
    onChange(pageNumber);
  };

  const onPrevious = () => {
    if(currentPage > 1) {
      setCurrentPage(currentPage - 1);
      onChange(currentPage - 1);
    }
  };

  const onNext = () => {
    if(currentPage < pageNumbers.length) {
      setCurrentPage(currentPage + 1);
      onChange(currentPage + 1);
    }
  };

  const pageNumbers = [];
  for(let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }
  return (
    <nav>
      <ul className="pagination pagination-square">
        <li className="page-item prev">
          <button type="button" className="page-link" onClick={onPrevious}>
            <i className="ti ti-chevron-left ti-xs"></i>
          </button>
        </li>
        {
          pageNumbers.slice(Math.max(currentPage - itemsPerPage, 0), currentPage + 2).map((number) => (
            <li key={number} className={`page-item ${currentPage === number ? 'active' : ''}`}>
              <button type="button" onClick={() => onPageSelected(number)} className="page-link">
                {number}
              </button>
            </li>
          ))
        }
        <li className="page-item next">
          <button type="button" className="page-link" onClick={onNext}>
            <i className="ti ti-chevron-right ti-xs"></i>
          </button>
        </li>
      </ul>
    </nav>
  );
};

interface Props {
  itemsPerPage: number,
  totalItems: number,
  page: number,
  onChange: (page: number) => void
}

export { Pagination };